import React from "react";
import H, { headerSizes } from "../elements/H";
import HorizontalSlider from "../slider/HorizontalSlider";
import {
  FaRegGrinBeam,
  FaRegGrinHearts,
  FaRegGrinStars,
  FaRegSmileWink,
  FaRegGrinSquint,
  FaRegSmile,
  FaRegSmileBeam,
  FaRegGrinWink,
  FaRegGrinAlt
} from "react-icons/fa";
import "./PremiumSlider.scss";

export interface PremiumSliderProps {
  /** Dollars per month, 1-9. */
  premiumAmount: number;
  setPremiumAmount: (amount: number) => void;
}

export default function PremiumSlider(props: PremiumSliderProps) {
  const faces = [
    <FaRegSmile />,
    <FaRegSmileWink />,
    <FaRegSmileBeam />,
    <FaRegGrinAlt />,
    <FaRegGrinWink />,
    <FaRegGrinBeam />,
    <FaRegGrinSquint />,
    <FaRegGrinStars />,
    <FaRegGrinHearts />
  ];

  const face = faces[props.premiumAmount - 1];
  return (
    <div>
      <H
        size={headerSizes.SMALL}
        textAlign="center"
        className="chosen-amount"
        usePermanentAccent={true}
      >
        ${props.premiumAmount}/month
      </H>
      <HorizontalSlider
        value={props.premiumAmount}
        onChange={props.setPremiumAmount}
        min={1}
        max={9}
        showMarks={true}
        renderThumb={thumbProps => (
          <div {...thumbProps} data-testid="slider-thumb">
            {face}
          </div>
        )}
        thumbClassName="premium-thumb"
        className="premium-slider"
      />
    </div>
  );
}
